import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useRecoilState } from 'recoil';

import {
  fetchUserData,
  key,
  refreshLegacyUserData
} from '../../core/APIHooks/userData/useGetUserData';
import { userData } from '../../recoil/atoms/userDataAtom';

export const useAuthMe = () => {
  const queryClient = useQueryClient();
  const [, setData] = useRecoilState(userData);

  const mutation = useMutation(async () => {
    const data = await refreshLegacyUserData(queryClient, { force: true });
    setData(data);
    return data;
  });

  return { ...mutation, isLoading: mutation.isLoading };
};

export const useAuthMeQuery = () => {
  const [, setData] = useRecoilState(userData);

  return useQuery(
    key,
    async () => {
      const data = await fetchUserData();
      setData(data);
      return data;
    },
    {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    }
  );
};
